import React,{useEffect,useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {RootState, AppDispatch} from '../../store/store';
import {fetchCashTrnsByInhand} from '../../store/slices/cashTransactionsSlice';
import { styles } from './cashTransactions.styles';
import AdminCashComponent from './AdminCashComponent';
import {
  Box,
  Container,
  Typography,
  Paper,
} from '@mui/material';
import AuditorCashComponent from './AuditorCashComponent';
 
 interface CashTransactionsProps {
  onTripClick?: (trip: any) => void;
  onTabChange?: (tabId: string) => void;
}
 
const CashTransactions: React.FC<CashTransactionsProps> = ({onTripClick, onTabChange}) => {
 
    const user = useSelector((state: RootState) => state.auth.user);
    const userRole = user?.role;
 
    return (
    <Container maxWidth="xl" sx={styles.container}>
        <Box sx={styles.headerBox}>
        {/* <Typography variant="h5" sx={styles.title}>
          Cash Transactions Management
        </Typography> */}
      </Box>
      <Box sx={styles.contentBox}>
        {/* Render component based on user role */}
        {userRole === 'ADMIN' ? (
          <AdminCashComponent/>
        ) : (
          <AuditorCashComponent/>
        )}
      </Box>
    </Container>
    )
}
 
export default CashTransactions;